<div class="holidays-dates page-layout" *transloco="let t">
  <app-holidays-dates-batch-actions></app-holidays-dates-batch-actions>

  <ng-container *ngIf="daysOff$ | withLoader | async as daysOff">
    <div class="holidays-dates-list page-layout-sub no-gutters">
      <div class="col table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ t('shared/date') }}</th>
              <th scope="col">{{ t('groups/name') }}</th>
              <th scope="col">{{ t('child/action') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="daysOff.results.length > 0; else noResults">
              <app-holidays-dates-row
                *ngFor="let dayOff of daysOff.results"
                (refreshDaysOff)="reloadDaysOff()"
                [dayOff]="dayOff"
              ></app-holidays-dates-row>
            </ng-container>

            <ng-template #noResults>
              <tr class="no-results" height="64px">
                <td>
                  {{ t('settings/noDaysOffFound') }}
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>

    <app-pagination
      *ngIf="daysOff.results.length > 0"
      [(page)]="page"
      (pageChange)="onPageChange($event)"
      [collectionSize]="daysOff.count"
      [pageSize]="limit"
      [showLimitSelector]="true"
      (limitChange)="onLimitChange($event)"
    ></app-pagination>
  </ng-container>
</div>
